import { Check } from 'lucide-react';
import { PLATFORM_FEE_NOTE, SAAS_PLANS } from 'modules/arena/onboarding/content';
import { Card } from 'shared/components/ui/Card';
import { Badge } from 'shared/components/ui/Badge';
import { Button } from 'shared/components/ui/Button';
import { useToast } from 'shared/components/ui/Toast';
import { useArenaProfile } from 'shared/contexts/ArenaProfileContext';

export function PlanSummaryCard() {
  const toast = useToast();
  const { profile } = useArenaProfile();
  const plan = SAAS_PLANS.find((item) => item.id === profile.planId) ?? SAAS_PLANS[1];

  return (
    <Card>
      <div className="flex items-center justify-between">
        <h3 className="font-heading font-semibold text-ink">Plano SaaS</h3>
        <Badge tone="success">Ativo</Badge>
      </div>
      <p className="mt-2 font-heading text-xl font-bold text-primary">
        {plan.name} · R$ {plan.price}
        <span className="text-sm font-normal text-ink-secondary">/mês</span>
      </p>
      <ul className="mt-2 flex flex-col gap-1 text-sm text-ink-secondary">
        {plan.features.map((feature) => (
          <li key={feature} className="flex items-start gap-2">
            <Check className="mt-0.5 h-4 w-4 flex-shrink-0 text-success" strokeWidth={2.5} aria-hidden="true" />
            {feature}
          </li>
        ))}
      </ul>
      <p className="mt-2 text-xs text-ink-secondary">{PLATFORM_FEE_NOTE}</p>
      <Button
        variant="ghost"
        className="mt-3 w-full"
        onClick={() =>
          toast({
            tone: 'info',
            title: 'Trocar de plano',
            description: 'Em breve: comparação entre planos e troca com cobrança proporcional.',
          })
        }
      >
        Trocar de plano
      </Button>
    </Card>
  );
}
